import { writable } from 'svelte/store';

export const isCartOpen = writable(false);
